import React from 'react';
import {useTranslation} from 'react-i18next';
import {
    IonButton, IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonSegment,
    IonSegmentButton, IonSegmentContent, IonSegmentView,
    IonSelect,
    IonSelectOption
} from '@ionic/react';
import PaymentItem from '../payments/PaymentItem';
import {PaymentMethod} from '../../services/types/apitypes';
import PaymentAddButton from '../payments/PaymentAddButton';
import {uiInputMode} from "../../utils/ui";
import {calendarOutline} from "ionicons/icons";

import './CardAutoloadPay.css';

type CardAutoloadPayProps = {
    selectedThreshold: number;
    setSelectedThreshold: (n: number) => void;
    paymentMethod: PaymentMethod | undefined;
    next: (p: PaymentMethod, dayOfMonth: number) => void;
    chosePayment: () => void;
    addPaymentMethod: () => void;
    isValid: boolean;
};

export default function CardAutoloadPay({
                                            selectedThreshold,
                                            setSelectedThreshold,
                                            addPaymentMethod,
                                            paymentMethod,
                                            chosePayment,
                                            isValid,
                                            next,
                                        }: CardAutoloadPayProps) {
    const [t] = useTranslation('global');
    const [segment, setSegment] = React.useState<'threshold' | 'date'>('threshold');
    const [selectedDay, setSelectedDay] = React.useState(1);

    const setValue = (v: string) => {
        let nv = parseInt(v);
        if (nv) {
            if (nv > 100) {
                nv = 100;
            }
            setSelectedThreshold(nv);
        } else {
            setSelectedThreshold(5);
        }
    };

    return (
        <>
            <h1 className="h1 h1plus pb-5 ion-text-center">
                {t('cardautoload.title')}
            </h1>

            <div style={{textAlign: 'left', marginBottom: '0.5rem', fontWeight: 700}}>
                {t('cardautoload.reloadbased')}:
            </div>

            <div>
                <IonSegment
                    value={segment}
                    onIonChange={e => setSegment(e.detail.value as 'threshold' | 'date')}
                    style={{marginBottom: '1.5rem'}}
                >
                    <IonSegmentButton value="threshold" contentId={"threshold"}>
                        <IonLabel>{t('cardautoload.reloadthreshold')}</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="date" contentId={"date"}>
                        <IonLabel>{t('cardautoload.reloaddate')}</IonLabel>
                    </IonSegmentButton>

                </IonSegment>
                <IonSegmentView>

                    <IonSegmentContent id={"threshold"}>

                        <div className="cardvalue-select-custom pb-2">
                            <div>
                                <b>{t('cardautoload.threshold')}</b>
                            </div>
                            <IonInput
                                value={selectedThreshold}
                                className="cardvalue-custominput"
                                fill="outline"
                                mode={uiInputMode()}
                                aria-label={t('cardautoload.threshold')!}
                                onIonInput={(e) => setValue(e.detail.value!)}
                                type="text"
                            ></IonInput>
                        </div>

                        <span className="autoload-explanation-text">{t('cardautoload.thresholdinfo')}</span>
                    </IonSegmentContent>
                    <IonSegmentContent id={"date"}>
                        <IonItem className="autoload-segment-item">
                                <IonSelect  mode="md"
                                    className="autoload-dateinput"
                                    style={{marginTop: "1rem"}}
                                    labelPlacement="floating"
                                    label={"Monthly Day"}
                                    fill="outline"
                                    placeholder="Select Day"
                                    toggleIcon={calendarOutline}
                                    value={selectedDay}
                                    onIonChange={e => setSelectedDay(e.detail.value)}
                                >
                                    <IonIcon slot="end" icon={calendarOutline} aria-hidden="true"></IonIcon>
                                    {Array.from({length: 31}, (_, i) => (
                                        <IonSelectOption key={i + 1} value={i + 1}>
                                            {i + 1}.
                                        </IonSelectOption>
                                    ))}
                                </IonSelect>
                        </IonItem>

                        <span className="autoload-sublabel-small">1.-31.</span>

                        <span className="autoload-explanation-text">{t('cardautoload.explanationautoloaddate')}</span>
                    </IonSegmentContent>
                </IonSegmentView>
            </div>


            <h1 className="h1 pt-4 pb-1">{t('cardautoload.payment')}</h1>

            {paymentMethod ? (
                <>
                    <PaymentItem payment={paymentMethod} click={() => chosePayment()}/>
                    <div className="pt-5 ion-text-center">
                        <IonButton
                            className={
                                'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
                            }
                            onClick={() => next(paymentMethod, (segment == 'date' ? selectedDay : -1))}
                        >
                            {t('cardautoload.save')}
                        </IonButton>
                    </div>
                </>
            ) : (
                <PaymentAddButton click={addPaymentMethod}/>
            )}
        </>
    );
}
